export default __webpack_public_path__ + "static/process2-885666ad8b2f01dd18f200f63956ce85.png";